import { Component, ComponentRef, Injector, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { GeocoderViewModel, SettingsService, TimezoneViewModel } from "../../../../services/settings.service";
import { LanguageModel, LanguageService } from "../../../../services/language.service";
import { TranslateService } from "@ngx-translate/core";
import { NewPasswordViewModel, UserCreateViewModel, UserViewModel, AccessRights, InterfacePermissions } from "../../../../services/users.service";
import { CompaniesService, CompanyModel } from 'app/services/companies.service';
import { ObjectsService } from "app/services/objects.service";
import { ObjectGroupViewModel } from "../../ObjectGroupViewModel";
import { UserObjectGroupAcl } from "app/models/UserObjectGroupAcl";
import { OBJECT_GROUP_ACL_GROUPS, getObjectGroupAclPresets, getObjectGroupFullAccessMask } from "app/system/shared/model/object-group-acl";
import { forkJoin, of } from "rxjs";
import { DialogService } from "app/services/dialog.service";
import { ObjectsManagementDialogComponent } from "../../objects-management-dialog/objects-management-dialog.component";

//TODO:check if this model still used or NewPasswordViewModel is already everywhere
export class ChangePasswordViewModel {
  UserId: number;
  OldPassword: string = "";
  Password: string = "";
  PasswordConfirmation: string = "";
}

export class RoleViewModel {

  Value: number = 0;
  BitNumber: number = 0;
  CheckBit: number = 0;
  Name: string = "";
}

@Component({
  selector: 'app-users-dialog-base',
  templateUrl: './users-dialog-base.component.html',
  styleUrls: ['./users-dialog-base.component.css'],
  standalone: false
})
export class UsersDialogBaseComponent<T extends UserViewModel> extends DialogBaseComponent<T> implements OnInit {
  public geocoders: GeocoderViewModel[] = [];
  public languages: LanguageModel[] = [];
  public timezones: TimezoneViewModel[] = [];
  public users: UserViewModel[] = [];
  public roles: RoleViewModel[] = [];
  public openedTabName: string = "userData";
  public objectGroups: ObjectGroupViewModel[] = [];
  public groupAccessTerm: string = "";
  public selectedAccessGroup: ObjectGroupViewModel | null = null;
  public selectedAccessGroupDetails: ObjectGroupViewModel | null = null;
  public selectedGroupUserAcl: number = 0;
  public activeGroupPresetMask: number | null = null;
  private groupDetailsCache: Map<number, ObjectGroupViewModel> = new Map();
  private pendingGroupAcl: Map<number, number> = new Map();
  private currentUserId: number = 0;
  private dirtyGroupIds: Set<number> = new Set<number>();
  private removedGroupIds: Set<number> = new Set<number>();

  public targetUser: UserViewModel;
  AccessRights = AccessRights;
  private languageService = inject(LanguageService);
  private settingsService = inject(SettingsService);
  private companyService = inject(CompaniesService);
  private objectsService = inject(ObjectsService);
  private dialogService = inject(DialogService);
  protected translateService = inject(TranslateService);
  private defaultRole: RoleViewModel;
  public companies: CompanyModel[];

  @ViewChild("groupsListDialog", { read: ViewContainerRef, static: false }) groupsListContainer: ViewContainerRef;
  private groupsListDialog: ComponentRef<any>;

  public readonly aclGroups = OBJECT_GROUP_ACL_GROUPS;
  public readonly aclPresets = getObjectGroupAclPresets();

  public openTab(name: string) {
    this.openedTabName = name;
    if (name === "groupAccess") {
      this.ensureGroupAccessState();
    }
  }

  public isSelected(name: string) {
    return name == this.openedTabName;
  }

  private GenerateRoles() {
    if (this.usersService.IsPermitted(AccessRights.EDIT_ALL_USERS)) {
      let role = new RoleViewModel();
      role.BitNumber = 24;
      role.CheckBit = 31;
      role.Value = 2147483647;
      role.Name = "Administrator";
      this.roles.push(role);
    }

    let role = new RoleViewModel();
    role.BitNumber = 16;
    role.CheckBit = 24;
    role.Value = 16777215;
    role.Name = "Integrator";
    this.roles.push(role);

    this.defaultRole = new RoleViewModel();
    this.defaultRole.BitNumber = 8;
    this.defaultRole.CheckBit = 16;
    this.defaultRole.Value = 65535;
    this.defaultRole.Name = "User";
    this.roles.push(this.defaultRole);

    role = new RoleViewModel();
    role.BitNumber = 4;
    role.CheckBit = 8;
    role.Value = 255;
    role.Name = "Demonstration";
    this.roles.push(role);

    role = new RoleViewModel();
    role.BitNumber = 2;
    role.CheckBit = 4;
    role.Value = 15;
    role.Name = "Observation";
    this.roles.push(role);
  }

  ngOnInit() {
    super.ngOnInit();
    this.GenerateRoles();
    //this.model.RoleDisplayName = this.defaultRole.Name;

    this.settingsService.getTimezones().subscribe(res => {
      this.timezones = res;
      if (this.model.TimeZone == "")
        this.model.TimeZone = this.timezones.find(tz => tz.Offset === 0).Name;
    });
    this.companyService.getCompanies().subscribe(res => {
      this.companies = res;
      if (this.model.CompanyId == 0)
        this.model.CompanyId = this.companies.find(c => c.Id == this.model.CompanyId).Id;
    });
    this.settingsService.getGeocoders().subscribe(res => {
      this.geocoders = res;
      this.model.Geocoder = this.geocoders[0].Name;
    });
    this.languageService.getLanguages().subscribe(res => {
      this.languages = res;
      this.model.Language = this.languageService.getLanguage().code;
    });
    const currentUser = this.usersService.getCurrentUser();
    this.currentUserId = currentUser?.Id ?? 0;
    if (this.model.Id == 0) {
      var superusers = this.getUsers();
      for (let i = 0; i < superusers.length; i++) {
        if (superusers[i].Id == currentUser.Id) {
          this.model.CompanyId = currentUser.Id;
          break;
        }
        if (superusers[i].Id == currentUser.CompanyId)
          this.model.CompanyId = currentUser.CompanyId;
      }

      this.model.InterfacePermissions = currentUser.InterfacePermissions;
    }

    this.loadObjectGroupsFromModel();
  }

  public onModelUpdated() {
    this.loadObjectGroupsFromModel();
    if (this.openedTabName === "groupAccess") {
      this.ensureGroupAccessState();
    }
  }

  close(): void {
    super.close();
    this.openedTabName = "userData";
  }

  public isCheckboxAvailable() {
    return ((this.model.Acl & 256) != 0) && ((this.model.Acl & 65536) == 0);
  }

  public onChangeMask(event: Event) {
    const input = event.currentTarget as HTMLInputElement;
    this.model.Acl = Number(input.value);
    if (this.openedTabName === "groupAccess" || this.objectGroups.length > 0) {
      this.loadObjectGroupsFromModel();
    }
  }
  public onChangeUnits(event: Event) {
    const value = (event.currentTarget as HTMLInputElement).value;
    if (value == "MILES")
      this.model.SetFlag("MILES");
    else
      this.model.ResetFlag("MILES");
  }
  public onChangeStartPage(event: Event) {
    const value = (event.currentTarget as HTMLInputElement).value;
    this.model.ResetFlag("START_DRIVERS");
    this.model.ResetFlag("START_FUEL");
    this.model.ResetFlag("START_REPORTS");
    this.model.ResetFlag("START_SERVICE");
    this.model.ResetFlag("START_ANALYTICS");
    this.model.ResetFlag("START_DISPATCHER");
    if (value != "")
      this.model.SetFlag(value);
  }

  public onToggleMask(bitNumber: number, event: Event) {
    const isOn = (event.target as HTMLInputElement).checked;
    this.toggleMask(isOn, bitNumber);
  }

  public toggleMask(isOn: boolean, bitNumber: number) {
    if (isOn)
      this.model.Acl = this.model.Acl | (1 << bitNumber);
    else
      this.model.Acl = this.model.Acl ^ (1 << bitNumber);
  }

  public onToggleInterfacePermissions(bitNumber: number, event: Event) {
    const isOn = (event.target as HTMLInputElement).checked;
    if (isOn)
      this.model.InterfacePermissions = this.model.InterfacePermissions | (1 << bitNumber);
    else
      this.model.InterfacePermissions = this.model.InterfacePermissions ^ (1 << bitNumber);
  }

  public InterfaceIsPermitted(bitNumber: InterfacePermissions) {
    return this.model.InterfaceIsPermitted(bitNumber);
  }

  public isRoleSelected(role: RoleViewModel) {
    return (this.model.Acl & (1 << role.CheckBit)) == 0 && (this.model.Acl & (1 << role.BitNumber)) != 0;
  }

  /*public resetPassword() {
    let message = this.translateService.instant("Password reset");
    if (!confirm(message + " " + this.model.Name + "?")) return;
    this.usersService.resetPassword(this.model.Id)
      .subscribe(() => {
        });
  }*/

  public isChecked(bitNumber: number) {
    return (this.model.Acl & (1 << bitNumber)) != 0;
  }

  constructor(protected injector: Injector) {
    super(injector);
  }

  changePassword() {
    let input = new NewPasswordViewModel();
    input.UserId = this.model.Id;
    input.Password = this.model.Password;
    input.PasswordConfirmation = this.model.PasswordConfirmation;
    this.usersService.changeUserPassword(input)
      .subscribe(() => {
        this.toastr.success(this.translateService.instant("Password successfully changed"));
      });
  }

  getUsers() {
    var users = this.users.filter(user => ((<UserViewModel>user).Acl & (1 << AccessRights.EDITUSERS)) != 0);

    if (this.targetUser)
      return users.filter(u => u.Id != this.targetUser.Id);
    else
      return users;
  }

  public get filteredAccessGroups(): ObjectGroupViewModel[] {
    const term = (this.groupAccessTerm || "").trim().toLowerCase();
    if (!term) return this.objectGroups;
    return this.objectGroups.filter(g => (g.Name || "").toLowerCase().includes(term));
  }

  public selectAccessGroup(group: ObjectGroupViewModel) {
    if (!group) return;
    this.selectedAccessGroup = group;
    this.loadGroupDetails(group.Id);
  }

  public openGroupPicker() {
    if (!this.canOpenGroupPicker()) return;
    this.groupsListDialog = this.dialogService.open(this.groupsListContainer, ObjectsManagementDialogComponent);
    this.groupsListDialog.instance.onOpen.subscribe(() => {
      this.groupsListDialog.instance.title = "Groups list";
      this.groupsListDialog.instance.groups = [];
      this.groupsListDialog.instance.objects = [];
      this.groupsListDialog.instance.companyLookup = this.buildCompanyLookup();
      this.groupsListDialog.instance.isLoading = true;
      this.usersService.getGroupsForUser(this.model?.Id ?? 0).subscribe({
        next: groups => {
          const existingIds = new Set(this.objectGroups.map(g => g.Id));
          let selectable = (groups ?? [])
            .filter(g => !existingIds.has(g.Id))
            .map(g => {
              const clone = Object.assign(new ObjectGroupViewModel(), g);
              clone.IsChecked = false;
              return clone;
            });
          if (this.isAdminEditor() || selectable.length === 0) {
            this.groupsListDialog.instance.objects = selectable;
            this.groupsListDialog.instance.isLoading = false;
            return;
          }
          forkJoin(selectable.map(g => this.objectsService.GetObjectGroup(g.Id))).subscribe({
            next: details => {
              const detailMap = new Map<number, ObjectGroupViewModel>();
              (details || []).forEach(detail => {
                if (!detail) return;
                detailMap.set(detail.Id, detail);
                this.groupDetailsCache.set(detail.Id, detail);
              });
              selectable = selectable.filter(g => this.canManageMembersInGroup(detailMap.get(g.Id) ?? g));
              this.groupsListDialog.instance.objects = selectable;
              this.groupsListDialog.instance.isLoading = false;
            },
            error: () => {
              selectable = selectable.filter(g => this.canManageMembersInGroup(g));
              this.groupsListDialog.instance.objects = selectable;
              this.groupsListDialog.instance.isLoading = false;
            }
          });
        },
        error: () => {
          this.groupsListDialog.instance.objects = [];
          this.groupsListDialog.instance.isLoading = false;
        }
      });
    });
    this.groupsListDialog.instance.onSubmit.subscribe(() => {
      const selected = (this.groupsListDialog.instance.objects || [])
        .filter((g: ObjectGroupViewModel) => g && g.IsChecked);
      if (selected.length > 0) {
        this.addGroupsToUser(selected);
      }
      this.groupsListDialog.instance.close();
    });
    this.groupsListDialog.instance.open();
  }

  public isGroupAclSet(acl: number): boolean {
    return (this.selectedGroupUserAcl & acl) === acl;
  }

  public isAclAllowedForGroup(acl: number): boolean {
    const maxMask = this.getMaxGroupAclMask();
    return (maxMask & acl) === acl;
  }

  private normalizeGroupAcl(acl: number): number {
    if ((acl & UserObjectGroupAcl.ChangeImei) === UserObjectGroupAcl.ChangeImei)
      acl |= UserObjectGroupAcl.EditObjects;
    if ((acl & UserObjectGroupAcl.ManageMembers) === UserObjectGroupAcl.ManageMembers)
      acl |= UserObjectGroupAcl.EditGroup;
    return acl;
  }

  private enforceGroupAclDependencies(acl: number): number {
    let next = this.normalizeGroupAcl(acl);
    if ((next & UserObjectGroupAcl.EditGroup) !== UserObjectGroupAcl.EditGroup) {
      next &= ~UserObjectGroupAcl.ManageMembers;
    }
    if ((next & UserObjectGroupAcl.EditObjects) !== UserObjectGroupAcl.EditObjects) {
      next &= ~UserObjectGroupAcl.ChangeImei;
    }
    return next;
  }

  public onGroupAclChange(acl: number, event: Event) {
    if (!this.canEditGroupRights) return;
    if (!this.selectedAccessGroupDetails || !this.model) return;
    const input = event.target as HTMLInputElement;
    let next = input.checked ? (this.selectedGroupUserAcl | acl) : (this.selectedGroupUserAcl & ~acl);
    if (!input.checked && acl === UserObjectGroupAcl.EditGroup) {
      next &= ~UserObjectGroupAcl.ManageMembers;
    }
    if (!input.checked && acl === UserObjectGroupAcl.EditObjects) {
      next &= ~UserObjectGroupAcl.ChangeImei;
    }
    next = this.enforceGroupAclDependencies(next);
    const maxMask = this.getMaxGroupAclMask();
    this.selectedGroupUserAcl = this.enforceGroupAclDependencies(next & maxMask);
    this.setGroupUserAcl(this.selectedGroupUserAcl);
  }

  public applyGroupPreset(mask: number) {
    if (!this.canEditGroupRights) return;
    if (!this.selectedAccessGroupDetails || !this.model) return;
    const maxMask = this.getMaxGroupAclMask();
    const normalized = this.enforceGroupAclDependencies(mask);
    this.selectedGroupUserAcl = normalized & maxMask;
    this.selectedGroupUserAcl = this.enforceGroupAclDependencies(this.selectedGroupUserAcl);
    this.activeGroupPresetMask = this.selectedGroupUserAcl;
    this.setGroupUserAcl(this.selectedGroupUserAcl);
  }

  public loadObjectGroupsFromModel() {
    if (!this.model) {
      this.objectGroups = [];
      this.resetGroupSelection();
      return;
    }
    if (!this.isTargetAdmin() && this.model.Id <= 0) {
      this.objectGroups = [];
      this.resetGroupSelection();
      return;
    }
    this.groupAccessTerm = "";
    this.pendingGroupAcl.clear();
    this.dirtyGroupIds.clear();
    this.removedGroupIds.clear();
    const links = this.model?.ObjectGroupLinks ?? [];
    if (links.length > 0) {
      links.forEach(link => {
        const rawGroupId = (link as any).ObjectGroupId ?? (link as any).objectGroupId;
        const rawAcl = (link as any).ACL ?? (link as any).acl;
        const groupId = typeof rawGroupId === "number" ? rawGroupId : Number(rawGroupId);
        const acl = typeof rawAcl === "number" ? rawAcl : Number(rawAcl);
        if (!Number.isNaN(groupId)) {
          this.pendingGroupAcl.set(groupId, Number.isNaN(acl) ? 0 : acl);
        }
      });
    }
    if (this.isTargetAdmin()) {
      this.loadAllObjectGroupsForAdmin();
      return;
    }
    this.loadObjectGroupsByMembership();
    return;
  }

  private loadAllObjectGroupsForAdmin() {
    if (this.model?.Id > 0) {
      this.objectsService.GetObjectGroupsByUser(this.model.Id).subscribe({
        next: groups => this.applyAdminGroups(groups ?? []),
        error: () => this.objectsService.GetObjectGroups().subscribe(groups => this.applyAdminGroups(groups ?? []))
      });
      return;
    }

    this.objectsService.GetObjectGroups().subscribe(groups => this.applyAdminGroups(groups ?? []));
  }

  private applyAdminGroups(groups: ObjectGroupViewModel[]) {
    this.objectGroups = [...(groups ?? [])]
      .sort((a, b) => (a.Name || "").localeCompare(b.Name || ""));
    this.pickFirstGroup();
  }

  private loadObjectGroupsByMembership(): void {
    if (!this.hasValidModelId()) {
      this.clearObjectGroups();
      return;
    }

    this.objectsService.GetObjectGroupsByUser(this.model.Id).subscribe({
      next: groups => this.handleMembershipGroups(groups ?? []),
      error: () => this.loadObjectGroupsByUserFallback()
    });
  }

  private handleMembershipGroups(groups: ObjectGroupViewModel[]): void {
    if (groups.length === 0) {
      this.loadObjectGroupsByUserFallback();
      return;
    }

    if (this.isTargetAdmin()) {
      this.applyAdminGroups(groups);
      return;
    }

    if (this.groupsContainUsers(groups)) {
      this.applyGroupsFromLoadedUsers(groups);
      return;
    }

    this.loadAndApplyGroupDetails(groups);
  }

  private applyGroupsFromLoadedUsers(groups: ObjectGroupViewModel[]): void {
    this.objectGroups = groups.filter(group => this.groupHasUser(group, this.model.Id));
    this.pickFirstGroup();
  }

  private loadAndApplyGroupDetails(groups: ObjectGroupViewModel[]): void {
    const requests = groups.map(group => this.objectsService.GetObjectGroup(group.Id));

    forkJoin(requests).subscribe(details => {
      const resolvedGroups = (details ?? []).filter(Boolean) as ObjectGroupViewModel[];

      resolvedGroups.forEach(group => {
        this.groupDetailsCache.set(group.Id, group);
      });

      this.objectGroups = resolvedGroups.filter(group => this.groupHasUser(group, this.model.Id));
      this.pickFirstGroup();
    });
  }

  private groupsContainUsers(groups: ObjectGroupViewModel[]): boolean {
    return groups.some(group => Array.isArray(group.Users) && group.Users.length > 0);
  }

  private hasValidModelId(): boolean {
    return !!this.model && this.model.Id > 0;
  }

  private clearObjectGroups(): void {
    this.objectGroups = [];
    this.resetGroupSelection();
  }

  private loadObjectGroupsByUserFallback() {
    if (!this.model || this.model.Id <= 0) return;
    this.objectsService.GetObjectGroups().subscribe(groups => {
      const base = groups ?? [];
      if (base.length === 0) {
        this.objectGroups = [];
        this.resetGroupSelection();
        return;
      }
      const hasUsersInfo = base.some(g => Array.isArray(g.Users) && g.Users.length > 0);
      if (hasUsersInfo) {
        this.objectGroups = base.filter(g => this.groupHasUser(g, this.model.Id));
        this.pickFirstGroup();
        return;
      }
      const requests = base.map(g => this.objectsService.GetObjectGroup(g.Id));
      forkJoin(requests.length > 0 ? requests : [of(null)]).subscribe(details => {
        const resolved = (details || []).filter(Boolean) as ObjectGroupViewModel[];
        resolved.forEach(g => this.groupDetailsCache.set(g.Id, g));
        this.objectGroups = resolved.filter(g => this.groupHasUser(g, this.model.Id));
        this.pickFirstGroup();
      });
    });
  }

  private loadObjectGroupsFallback() {
    if (!this.model || this.model.Id <= 0) {
      this.objectGroups = [];
      this.resetGroupSelection();
      return;
    }
    const linkIds = new Set(
      (this.model.ObjectGroupLinks ?? [])
        .map(x => (x as any).ObjectGroupId ?? (x as any).objectGroupId)
        .map((id: any) => typeof id === "number" ? id : Number(id))
        .filter((id: any) => !Number.isNaN(id))
    );
    if (linkIds.size === 0) {
      this.loadObjectGroupsByMembership();
      return;
    }
    this.objectsService.GetObjectGroups().subscribe(groups => {
      const base = (groups ?? []).filter(g => linkIds.has(g.Id));
      if (base.length === 0) {
        this.objectGroups = [];
        this.resetGroupSelection();
        return;
      }
      const hasUsersInfo = base.some(g => Array.isArray(g.Users) && g.Users.length > 0);
      if (hasUsersInfo) {
        this.objectGroups = base.filter(g => this.groupHasUser(g, this.model.Id));
        this.pickFirstGroup();
        return;
      }
      const requests = base.map(g => this.objectsService.GetObjectGroup(g.Id));
      forkJoin(requests.length > 0 ? requests : [of(null)]).subscribe(details => {
        const resolved = (details || []).filter(Boolean) as ObjectGroupViewModel[];
        resolved.forEach(g => this.groupDetailsCache.set(g.Id, g));
        this.objectGroups = resolved.filter(g => this.groupHasUser(g, this.model.Id));
        this.pickFirstGroup();
      });
    });
  }

  private ensureGroupAccessState() {
    if (this.objectGroups.length === 0) {
      this.loadObjectGroupsFromModel();
      return;
    }
    if (this.selectedAccessGroupDetails) {
      this.setSelectedGroupDetails(this.selectedAccessGroupDetails);
      return;
    }
    if (this.selectedAccessGroup) {
      this.loadGroupDetails(this.selectedAccessGroup.Id);
    } else {
      this.pickFirstGroup();
    }
  }

  private loadGroupDetails(groupId: number) {
    const cached = this.groupDetailsCache.get(groupId);
    if (cached) {
      this.setSelectedGroupDetails(cached);
      return;
    }
    this.objectsService.GetObjectGroup(groupId).subscribe(group => {
      this.groupDetailsCache.set(groupId, group);
      this.setSelectedGroupDetails(group);
    });
  }

  private setSelectedGroupDetails(group: ObjectGroupViewModel) {
    this.selectedAccessGroupDetails = group;
    const pending = this.pendingGroupAcl.get(group.Id);
    this.selectedGroupUserAcl = this.isTargetAdmin()
      ? getObjectGroupFullAccessMask()
      : (typeof pending === "number" ? pending : this.getUserAclFromGroup(group));
    this.selectedGroupUserAcl = this.enforceGroupAclDependencies(this.selectedGroupUserAcl);
    this.activeGroupPresetMask = this.selectedGroupUserAcl;
  }

  private getUserAclFromGroup(group: ObjectGroupViewModel): number {
    if (this.isTargetAdmin()) {
      return getObjectGroupFullAccessMask();
    }

    const pending = this.pendingGroupAcl.get(group?.Id ?? 0);
    if (typeof pending === "number") return pending;
    const link = (group?.Users ?? []).find(x => (x as any).userId === this.model.Id || (x as any).UserId === this.model.Id);
    const acl = (link as any)?.acl ?? (link as any)?.ACL;
    return typeof acl === "number" ? acl : 0;
  }

  private setGroupUserAcl(acl: number) {
    if (!this.selectedAccessGroupDetails || !this.model) return;
    acl = this.enforceGroupAclDependencies(acl);
    const links = [...(this.selectedAccessGroupDetails.Users ?? [])];
    let link = links.find(x => (x as any).userId === this.model.Id || (x as any).UserId === this.model.Id);
    if (link) {
      (link as any).acl = acl;
      (link as any).ACL = acl;
    } else {
      if (this.model.Id > 0) {
        links.push({ userId: this.model.Id, acl });
      }
    }
    this.selectedAccessGroupDetails.Users = links;
    if (this.selectedAccessGroupDetails.Id > 0) {
      this.dirtyGroupIds.add(this.selectedAccessGroupDetails.Id);
    }
    this.pendingGroupAcl.set(this.selectedAccessGroupDetails.Id, acl);
  }

  public buildObjectGroupLinksForSave(): { ObjectGroupId: number; ACL: number }[] {
    return this.objectGroups.map(group => {
      const pending = this.pendingGroupAcl.get(group.Id);
      const acl = typeof pending === "number" ? pending : this.getUserAclFromGroup(group);
      return { ObjectGroupId: group.Id, ACL: acl };
    });
  }

  protected buildSubmitModel(): T {
    const model = { ...this.model } as T;
    (model as any).ObjectGroupLinks = this.buildObjectGroupLinksForSave();
    return model;
  }

  private addGroupsToUser(groups: ObjectGroupViewModel[]) {
    if (!groups || groups.length === 0) return;
    const defaultAcl = 0;
    const addedGroups: ObjectGroupViewModel[] = [];
    groups.forEach(group => {
      if (!this.isAdminEditor() && !this.canManageMembersInGroup(group)) return;
      if (this.objectGroups.some(g => g.Id === group.Id)) return;
      this.objectGroups.push(group);
      this.groupDetailsCache.set(group.Id, group);
      this.pendingGroupAcl.set(group.Id, defaultAcl);
      this.dirtyGroupIds.add(group.Id);
      this.removedGroupIds.delete(group.Id);
      addedGroups.push(group);
    });
    this.objectGroups = [...this.objectGroups].sort((a, b) => (a.Name || "").localeCompare(b.Name || ""));
    if (!this.selectedAccessGroup && this.objectGroups.length > 0) {
      this.selectAccessGroup(this.objectGroups[0]);
    }
    if (addedGroups.length > 0) {
      forkJoin(addedGroups.map(g => this.objectsService.GetObjectGroup(g.Id))).subscribe(details => {
        (details || []).forEach(detail => {
          if (!detail) return;
          this.groupDetailsCache.set(detail.Id, detail);
          if (this.selectedAccessGroup && this.selectedAccessGroup.Id === detail.Id) {
            this.setSelectedGroupDetails(detail);
          }
        });
      });
    }
  }

  private groupHasUser(group: ObjectGroupViewModel, userId: number): boolean {
    if (!group || userId <= 0) return false;
    const links = (group.Users ?? []) as any[];
    return links.some(x => {
      const rawUserId = x?.userId ?? x?.UserId;
      const linkUserId = typeof rawUserId === "number" ? rawUserId : Number(rawUserId);
      return linkUserId === userId;
    });
  }

  private pickFirstGroup() {
    if (this.objectGroups.length > 0) {
      this.selectAccessGroup(this.objectGroups[0]);
    } else {
      this.resetGroupSelection();
    }
  }

  private resetGroupSelection() {
    this.selectedAccessGroup = null;
    this.selectedAccessGroupDetails = null;
    this.selectedGroupUserAcl = 0;
    this.activeGroupPresetMask = null;
  }

  public removeGroupFromUser(group: ObjectGroupViewModel, event?: Event) {
    if (event) event.stopPropagation();
    if (!this.canRemoveGroupFromUser(group)) return;
    if (!group || group.Id <= 0) return;
    const message = this.translateService.instant("Delete");
    if (!confirm(message + " " + group.Name + "?")) return;

    this.objectGroups = this.objectGroups.filter(g => g.Id !== group.Id);
    this.groupDetailsCache.delete(group.Id);
    this.pendingGroupAcl.delete(group.Id);
    this.dirtyGroupIds.delete(group.Id);
    this.removedGroupIds.add(group.Id);

    if (this.selectedAccessGroup?.Id === group.Id) {
      this.pickFirstGroup();
    }
  }

  private getMaxGroupAclMask(): number {
    if (this.isTargetAdmin()) {
      return getObjectGroupFullAccessMask();
    }
    if (this.isAdminEditor()) {
      return getObjectGroupFullAccessMask();
    }
    const link = (this.selectedAccessGroupDetails?.Users ?? []).find(x =>
      (x as any).userId === this.currentUserId || (x as any).UserId === this.currentUserId);
    const acl = (link as any)?.acl
      ?? (link as any)?.ACL
      ?? this.usersService.getCurrentUser()?.ObjectGroupLinks?.find(x => x.ObjectGroupId === this.selectedAccessGroupDetails?.Id)?.ACL;
    return typeof acl === "number" ? acl : 0;
  }

  private get isEditingSelf(): boolean {
    return !!this.model && this.model.Id > 0 && this.model.Id === this.currentUserId;
  }

  private isAdminEditor(): boolean {
    return this.usersService.IsPermitted(AccessRights.EDITUSERS) || this.usersService.IsPermitted(AccessRights.EDIT_ALL_USERS);
  }

  private isTargetAdmin(): boolean {
    if (!this.model) return false;
    return ((this.model.Acl & (1 << AccessRights.EDITUSERS)) !== 0)
      || ((this.model.Acl & (1 << AccessRights.EDIT_ALL_USERS)) !== 0);
  }

  public canManageMembersInGroup(group?: ObjectGroupViewModel | null): boolean {
    if (!group || !group.Id || this.isEditingSelf) return false;
    if (group.CanSelect) {
      if (this.isAdminEditor()) return true;
      const details = this.groupDetailsCache.get(group.Id) ?? group;
      const link = (details.Users ?? []).find(x =>
        (x as any).userId === this.currentUserId || (x as any).UserId === this.currentUserId);
      const acl = (link as any)?.acl
        ?? (link as any)?.ACL
        ?? this.usersService.getCurrentUser()?.ObjectGroupLinks?.find(x => x.ObjectGroupId === group.Id)?.ACL;
      return typeof acl === "number" && (acl & UserObjectGroupAcl.ManageMembers) === UserObjectGroupAcl.ManageMembers;
    }
    return false;
  }

  public canOpenGroupPicker(): boolean {
    if (this.isEditingSelf) return false;
    return true;
  }

  private buildCompanyLookup(): { [key: number]: string } | null {
    if (!this.companies || this.companies.length === 0) return null;
    const lookup: { [key: number]: string } = {};
    this.companies.forEach(company => {
      lookup[company.Id] = company.Name;
    });
    return lookup;
  }

  public getGroupCompanyName(companyId: number): string {
    return this.companies?.find(company => company.Id === companyId)?.Name ?? "";
  }

  public canEditAclForSelectedGroup(): boolean {
    return this.canManageMembersInGroup(this.selectedAccessGroupDetails ?? this.selectedAccessGroup);
  }

  public canRemoveGroupFromUser(group: ObjectGroupViewModel): boolean {
    return this.canManageMembersInGroup(group);
  }

  public get canEditGroupRights(): boolean {
    return this.canEditAclForSelectedGroup();
  }

}
